import React from 'react'
import { RichTextSerializer } from '../../../Serializers';
import ArticleV2DrawerSection from './ArticleV2DrawerSection';
import ArticleV2ShapeBlockQuote from './ArticleV2ShapeBlockQuote';
import ArticleV2PaddedSectionWrap from './ArticleV2PaddedSectionWrap';
import ArticleV2Image from './ArticleV2Image';
import ArticleV2VideoFile from './ArticleV2VideoFile';
import ArticleV2VideoYoutube from './ArticleV2VideoYoutube';
import ArticleV2DropCap from './ArticleV2DropCap';
import ArticleV2VideoBrightcove from './ArticleV2VideoBrightcove';

const ArticleV2ContentSection = ({data, idx, dropCapColor}) => {
    data = data || [];

    return (
        <div className='article-v2-content'>
            {data.map((section, idx) => {
                const key = `sec-${idx}-${section.id}`;

                if (section.__typename === 'ContentfulTextBlock') {
                    if (!section.content) return null;
                    return (
                        <ArticleV2PaddedSectionWrap key={key}>
                            {idx ===0 ? <ArticleV2DropCap dropCapColor={dropCapColor}/> : null}
                            <RichTextSerializer content={section.content}/>
                        </ArticleV2PaddedSectionWrap>
                    )
                }

                if (section.__typename === 'ContentfulImage') {
                    return (
                        <ArticleV2PaddedSectionWrap key={key}>
                            <ArticleV2Image image={section.image}/>
                        </ArticleV2PaddedSectionWrap>
                    )
                }

                if (section.__typename === 'ContentfulVideo') {
                    let videoType = section.videoType;
                    let toRender = null;

                    switch(videoType) {
                        case 'Video File':
                            toRender = <ArticleV2VideoFile video={section.content}/>
                            break;
                        case "Youtube Embed":
                            toRender = <ArticleV2VideoYoutube youtubeEmbedId={section.youtubeEmbedId}/>
                            break;
                        case "Brightcove Embed":
                            toRender = <ArticleV2VideoBrightcove BrightcoveVideoId={section}/>
                            break;
                        
                    }

                    return (
                        <ArticleV2PaddedSectionWrap key={key}>
                            {toRender}
                        </ArticleV2PaddedSectionWrap>
                    )
                }

                if (section.__typename === 'ContentfulV2DrawerContent') {
                    return <ArticleV2DrawerSection key={key} data={section}/>
                }
                
                if (section.__typename === 'ContentfulV2ShapeBlockQuote') {
                    return (
                        <ArticleV2PaddedSectionWrap key={key}>
                            <ArticleV2ShapeBlockQuote data={section} />
                        </ArticleV2PaddedSectionWrap>
                    )
                }
            })}

            <style jsx>{`
                div {
                    position: relative;
                    z-index: 1;
                }

                .article-v2-content :global(.text) {
                    // margin: 2.5rem 0;
                    // padding: 2.5rem 0;
                    padding-bottom: 2.5rem;
                    margin: 0;
                }

                .article-v2-content :global(h3) {
                    padding-top: 1.5rem;
                    padding-bottom: 1.5rem;
                }

                .article-v2-content :global(.text:last-of-type) {
                    // margin-bottom: 2.5rem;
                    // padding-bottom: 2.5rem;
                }

            `}</style>
        </div>
    )
}

export default ArticleV2ContentSection